import StaffName from './StaffName.vue'

StaffName.install = (Vue) => {
    Vue.component(StaffName.name, StaffName)
}

export default StaffName
